import {
  EarIcon,
  FootprintsIcon,
  GlassesIcon,
  HandIcon,
  HardHatIcon,
  ShieldIcon,
  ShirtIcon,
  WrenchIcon,
} from 'assets/icons/toolFamilyIcons';

/** Lower case, without accents: "Chaussures de sécurité" and "chaussure securite" match. */
const normalize = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

// Same families as company (components/missionDetail/missionDetailIcons.js) and
// the temp worker app, so a piece of equipment shows the same icon everywhere.
const TOOL_FAMILIES = [
  {
    icon: EarIcon,
    words: ['anti-bruit', 'antibruit', 'auditi', 'bouchon', 'oreille'],
  },
  {
    icon: FootprintsIcon,
    words: ['chaussure', 'botte', 'sabot', 'basket', 'semelle'],
  },
  { icon: HardHatIcon, words: ['casque', 'casquette', 'charlotte', 'bonnet'] },
  { icon: HandIcon, words: ['gant', 'manchette'] },
  {
    icon: GlassesIcon,
    words: ['lunette', 'visiere', 'masque', 'ecran facial'],
  },
  {
    icon: ShieldIcon,
    words: ['harnais', 'longe', 'antichute', 'anti-chute', 'genouill'],
  },
  {
    icon: ShirtIcon,
    words: [
      'gilet',
      'veste',
      'tenue',
      'combinaison',
      'blouse',
      'pantalon',
      'tablier',
      'vetement',
      'parka',
      'tee-shirt',
      't-shirt',
    ],
  },
];

export const toolIcon = (name) => {
  const text = normalize(name);
  return (
    TOOL_FAMILIES.find((family) =>
      family.words.some((word) => text.includes(word))
    )?.icon ?? WrenchIcon
  );
};
